<template>
  <div class="simple-dropdown">
    <select 
      :id="id" 
      :name="id" 
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :disabled="disabled"
      class="simple-select"
    >
      <option value="">{{ placeholder }}</option>
      <option v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SimpleDropdown',
  props: {
    id: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '選択してください'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.simple-dropdown {
  width: 100%;
  position: relative;
}

.simple-select {
  width: 100%;
  padding: 8px;
  border: 2px solid #195983;
  border-radius: 4px;
  background-color: white;
  color: #333;
  font-size: 14px;
  height: 38px;
}

.reset-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0;
  font-size: 12px;
}

.reset-button:hover {
  color: #333;
}
</style>
